// dispatch consts A stands for Action Type
export enum STDOUT_TYPES {
  A_LANGUAGE_CHANGE,
  A_MESSAGE,
  A_CODE_RUN_RESULT,
  A_CODE_RUN,
}

export enum CHAT_TYPES {
  A_SENT_MESSAGE,
}

export enum USER_TYPES {
  A_USERNAME_CHANGE,
}
